// 组件
import d2ContainerFull from './components/e2-container-full.vue';
import d2ContainerCard from './components/e2-container-card.vue';

import './index.less';

export default {
  name: 'e2-container',
  props: {
    type: {
      type: String,
      required: false,
      default: 'full',
    },
  },
  computed: {
    // 始终返回渲染组件
    component() {
      if (this.type === 'card') {
        return d2ContainerCard;
      }
      if (this.type === 'full') {
        return d2ContainerFull;
      }
      return 'div';
    },
  },
  render(h) {
    const slots = [this.$slots.default];
    if (this.$slots.header) slots.push(h('template', { slot: 'header' }, [this.$slots.header]));
    if (this.$slots.footer) slots.push(h('template', { slot: 'footer' }, [this.$slots.footer]));
    return h(
      'div',
      {
        ref: 'container',
        class: 'container-component',
      },
      [
        h(
          this.component,
          {
            ref: 'component',
            props: this.$attrs,
          },
          slots,
        ),
      ],
    );
  },
  methods: {},
};
